module.exports = __webpack_public_path__ + "img/att_hz_lg_lkp_rgb_pos.46f4db30.png";